import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { star, starOutline } from 'ionicons/icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'RateWithStars',
  props: {
    value: {},
    maxStars: {},
    shouldUpdate: { type: Boolean }
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const rating = ref(props.value);
const updateValue = (value: number) => {
  if (props.shouldUpdate) {
    rating.value = value;
    emit('update:value', value);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxStars, (i) => {
    return (_openBlock(), _createBlock(_component_ion_icon, {
      key: `stars-${i}`,
      color: i <= _ctx.value ? 'warning' : 'medium',
      icon: (i <= _ctx.value) ? _unref(star) : _unref(starOutline),
      size: "large",
      onClick: ($event: any) => (updateValue(i))
    }, null, 8, ["color", "icon", "onClick"]))
  }), 128))
}
}

})